export default __webpack_public_path__ + "static/media/align-left.f0900bf9.svg";